import { render, staticRenderFns } from "./injectionPro.vue?vue&type=template&id=70078e6c&"
import script from "./injectionPro.vue?vue&type=script&lang=js&"
export * from "./injectionPro.vue?vue&type=script&lang=js&"
import style0 from "./injectionPro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "injectionPro.vue"
export default component.exports